module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('columns', [_c('column', {
    attrs: {
      "size": "4"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('logo', {
    attrs: {
      "type": "night"
    }
  })], 1)], 1), _vm._v(" "), _c('column', {
    attrs: {
      "size": "4"
    }
  }, [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": "/about"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.resetBodyClass($event)
      }
    }
  }, [_vm._v("О компании")]), _vm._v(" "), _c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": "/vacancies"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.resetBodyClass($event)
      }
    }
  }, [_vm._v("Вакансии")]), _vm._v(" "), _c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": "/legal"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.resetBodyClass($event)
      }
    }
  }, [_vm._v("Раскрытие"), _c('br'), _vm._v("информации")]), _vm._v(" "), _c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": "/contacts"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.resetBodyClass($event)
      }
    }
  }, [_vm._v("Контакты")]), _vm._v(" "), _c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": "/profile"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.resetBodyClass($event)
      }
    }
  }, [_vm._v("Личный кабинет")])], 1), _vm._v(" "), _c('column', {
    attrs: {
      "size": "4"
    }
  }, [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": "/power"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.resetBodyClass($event)
      }
    }
  }, [_vm._v("Энергосбережение")]), _vm._v(" "), _c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": "/accounting"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.resetBodyClass($event)
      }
    }
  }, [_vm._v("Системы учёта")]), _vm._v(" "), _c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": "/audit"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.resetBodyClass($event)
      }
    }
  }, [_vm._v("Энергоаудит")]), _vm._v(" "), _c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": "/consulting"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.resetBodyClass($event)
      }
    }
  }, [_vm._v("Консалтинг")]), _vm._v(" "), _c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": "/trading"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.resetBodyClass($event)
      }
    }
  }, [_vm._v("Энерготрейдинг")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eded43a2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeaderBar.vue
// module id = 142
// module chunks = 0